export const CONTACT_INFO = [
  {
    icon: 'fas fa-map-marker-alt',
    type: 'address',
    content: `Gopal Krishna Building, Sector 30/31, CBD Belapur, 
      Navi Mumbai, Maharashtra 400614`,
  },
  {
    icon: 'fas fa-phone-alt',
    type: 'phone',
    content: '+91 8986790869',
  },
  {
    icon: 'far fa-envelope',
    type: 'email',
    content: 'contact@appthing.in',
  },
];

export const SOCIAL_LINKS = [
  { icon: 'bx bxl-linkedin', url: 'https://www.linkedin.com/company/appthing' },
  { icon: 'bx bxl-twitter', url: 'https://x.com/AppThing_HQ' },
  // { icon: "bx bxl-facebook", url: "https://www.facebook.com/appthing" },
  // { icon: "bx bxl-instagram", url: "https://www.instagram.com/appthing" },
];

export const CONTACT_FORM = [
  { label: 'Name', type: 'text', className: 'col-lg-12 mb-20' },
  {
    label: 'Company / Organization',
    type: 'text',
    className: 'col-lg-12 mb-20',
  },
  { label: 'Email', type: 'email', className: 'col-lg-12 mb-20' },
  { label: 'Phone', type: 'tel', className: 'col-lg-12 mb-20' },
];
